import { render, staticRenderFns } from "./listMarketing.vue?vue&type=template&id=e0ab0bce&scoped=true"
import script from "./listMarketing.vue?vue&type=script&lang=js"
export * from "./listMarketing.vue?vue&type=script&lang=js"
import style0 from "./listMarketing.vue?vue&type=style&index=0&id=e0ab0bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ab0bce",
  null
  
)

export default component.exports